var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.totalUnread)?_c('jds-meridian-badge',[_vm._v("\n    "+_vm._s((_vm.totalUnread >= _vm.maxValue) ? `${_vm.maxValue}+` : _vm.totalUnread)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }